<template>
  <div class="bg">
    <div class="body">
      <h1 class="mod-title">
        <span class="ico_log" :class="'ico-' + pay_qrcode.type"></span>
      </h1>

      <div class="mod-ct">
        <div class="order"></div>
        <div class="amount" id="money">￥ {{ pay_qrcode.money }}</div>
        <div class="qrcode-img-wrapper" data-role="qrPayImgWrapper">
          <div data-role="qrPayImg" class="qrcode-img-area">
            <div style="position: relative; display: inline-block">
              <img
                v-if="!overtime"
                v-lazy="pay_qrcode.qrcode"
                style="display: block; width: 210px"
              />
              <img
                v-else
                src="../../../assets/img/loading.gif"
                style="display: block; width: 210px"
              />
            </div>
          </div>
        </div>
        <div class="time-item" id="msg">
          <h1 v-if="!overtime">二维码过期时间</h1>
          <h1 v-else>支付超时 请刷新页面</h1>
          <van-count-down :time="countDown">
            <template #default="timeData">
              <span class="block">{{ timeData.hours }}时</span>
              <span class="colon">:</span>
              <span class="block">{{ timeData.minutes }}分</span>
              <span class="colon">:</span>
              <span class="block">{{ timeData.seconds }}秒</span>
            </template>
          </van-count-down>
          <br />
          <font color="red" style="font-size: 12px"
            >请务必付款与提示金额相同的金额 否则无效</font
          >
        </div>

        <div class="tip">
          <div class="ico-scan"></div>
          <div class="tip-text">
            <p>请使用{{ pay_qrcode.type == 1 ? "支付宝" : "微信" }}扫一扫</p>
            <p>扫描二维码完成支付</p>
          </div>
        </div>

        <div class="detail" :class="open ? 'detail-open' : ''">
          <dl class="detail-ct" :style="open ? 'height: 105px' : ''">
            <dt>商品</dt>
            <dd>{{ order.goods_name }}</dd>
            <dt>金额</dt>
            <dd>￥{{ pay_qrcode.money }}</dd>
            <dt>创建时间</dt>
            <dd>{{ order.addTime }}</dd>
          </dl>
          <a href="javascript:void(0)" class="arrow" @click="open = !open"
            ><i class="ico-arrow"></i
          ></a>
        </div>

        <div class="tip-text"></div>
      </div>
      <div class="foot">
        <div class="inner">
          <p>手机用户可保存上方二维码到手机中</p>
          <p>
            在{{
              pay_qrcode.type == 1 ? "支付宝" : "微信"
            }}扫一扫中选择“相册”即可
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { postPay, getOrder, getStatus } from "@/api/index";

export default {
  data() {
    return {
      open: false,
      out_trade_no: "",
      order: {},
      overtime: false,
      countDown: "",
      pay_qrcode: {},
    };
  },
  created() {
    this._getOrder(this.$route.params.out_trade_no);
    this.out_trade_no = this.$route.params.out_trade_no;
    if (
      // 非相同订单
      this.$store.state.pay_qrcode.pay_id != this.$route.params.out_trade_no
    ) {
      this._postPay(this.$route.params.out_trade_no);
    } else {
      // 相同订单
      let timestamp = Date.parse(new Date());
      if (timestamp / 1000 < this.$store.state.pay_qrcode.endTime) {
        this.pay_qrcode = this.$store.state.pay_qrcode;
        this.countDown =
          (this.$store.state.pay_qrcode.endTime - timestamp / 1000) * 1000;
      } else {
        this._postPay(this.$route.params.out_trade_no);
      }
    }
  },
  mounted() {
    let _this = this; // 声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(() => {
      let now = Date.parse(new Date()); // 修改数据date
      if (now / 1000 >= _this.pay_qrcode.endTime) {
        _this.overtime = true;
        clearInterval(_this.timer);
        clearInterval(_this.timers);
      }
    }, 1000);

    this.timers = setInterval(() => {
      _this._getStatus(_this.out_trade_no);
    }, 3000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
  },

  methods: {
    // 提交支付
    _postPay(out_trade_no) {
      postPay({
        out_trade_no: out_trade_no,
      }).then((res) => {
        if (res.code == 200) {
          let timestamp = Date.parse(new Date());
          this.$store.state.pay_qrcode = res.data;
          this.pay_qrcode = res.data;
          this.countDown = (res.data.endTime - timestamp / 1000) * 1000;
        } else {
          this.$Message.error({
            background: true,
            content: res.msg,
          });
        }
      });
    },

    // 查询订单
    _getOrder(out_trade_no) {
      getOrder({
        out_trade_no,
      }).then((res) => {
        if (res.code == 200) {
          this.order = res.data;
        } else {
          this.$Message.error({
            background: true,
            content: res.msg,
          });
        }
      });
    },

    // 查询状态
    _getStatus(out_trade_no) {
      getStatus({
        out_trade_no: out_trade_no,
      }).then((res) => {
        if (res.data) {
          clearInterval(this.timers);
          
          if (document.body.clientWidth > 992) {
            this.$router.push('/query');
          }else{
            this.$router.push('/m/query');

          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@charset "UTF-8";
html {
  font-size: 62.5%;
  font-family: "helvetica neue", tahoma, arial, "hiragino sans gb",
    "microsoft yahei", "Simsun", sans-serif;
}

body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
legend,
input,
button,
textarea,
p,
blockquote,
th,
td,
hr {
  margin: 0;
  padding: 0px 2px;
}
.bg {
  background: #f7f7f7;
  min-height: 100vh;
  width: 100%;
  overflow: hidden;
}
body {
  line-height: 1.333;
  font-size: 12px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-family: arial, "hiragino sans gb", "microsoft yahei", "Simsun",
    sans-serif;
}

input,
textarea,
select,
button {
  font-size: 12px;
  font-weight: normal;
}

input[type="button"],
input[type="submit"],
select,
button {
  cursor: pointer;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

address,
caption,
cite,
code,
dfn,
em,
th,
var {
  font-style: normal;
  font-weight: normal;
}

li {
  list-style: none;
}

caption,
th {
  text-align: left;
}

q:before,
q:after {
  content: "";
}

abbr,
acronym {
  border: 0;
  font-variant: normal;
}

sup {
  vertical-align: text-top;
}

sub {
  vertical-align: text-bottom;
}

fieldset,
img,
a img,
iframe {
  border-width: 0;
  border-style: none;
}

img {
  -ms-interpolation-mode: bicubic;
}

textarea {
  overflow-y: auto;
}

legend {
  color: #000;
}

a:link,
a:visited {
  text-decoration: none;
}

hr {
  height: 0;
}

label {
  cursor: pointer;
}

a {
  color: #328ce5;
}

a:hover {
  color: #2b8ae8;
  text-decoration: none;
}

a:focus {
  outline: none;
}

body,
.body {
  background: #f7f7f7;
  height: 100%;
  max-width: 640px;
  min-width: 300px;
  min-height: 100%;

  margin: 0 auto;
}

.mod-title {
  height: 60px;
  line-height: 60px;
  text-align: center;
  border-bottom: 1px solid #ddd;
  background: #fff;
}

.ico_log {
  display: inline-block;
  width: 130px;
  height: 38px;
  vertical-align: middle;
  margin-right: 7px;
}

.ico-1 {
  background: url("../../../assets/img/alipay.jpg") no-repeat;
}

.ico-3 {
  background: url("../../../assets/img/weixin.jpg") no-repeat;
}

.mod-title .text {
  font-size: 20px;
  color: #333;
  font-weight: normal;
  vertical-align: middle;
}

.mod-ct {
  min-width: 300px;
  max-width: 640px;
  margin: 0 auto;
  margin-top: 15px;
  background: #fff url("../../../assets/img/wave.png") top center repeat-x;
  text-align: center;
  color: #333;
  border: 1px solid #e5e5e5;
  border-top: none;
}

.mod-ct .order {
  font-size: 20px;
  padding-top: 10px;
}

.mod-ct .amount {
  font-size: 48px;
  margin-top: 10px;
}

.mod-ct .qr-image {
  margin-top: 30px;
}

.mod-ct .qr-image img {
  width: 230px;
  height: 230px;
}

.mod-ct .detail {
  margin-top: 10px;
  padding-top: 0px;
  padding-bottom: 10px;
}

.mod-ct .detail .arrow .ico-arrow {
  display: inline-block;
  width: 20px;
  height: 11px;
  background: url("../../../assets/img/wechat-pay.png") -25px -100px no-repeat;
}

.mod-ct .detail .detail-ct {
  font-size: 12px;
  text-align: right;
  line-height: 28px;
  height: 0;
  padding-top: 10px;
  overflow: hidden;
  transition: all 0.5s;
  -moz-transition: all 0.5s; /* Firefox 4 */
  -webkit-transition: all 0.5s; /* Safari 和 Chrome */
  -o-transition: all 0.5s; /* Opera */
}

.mod-ct .detail .detail-ct dt {
  float: left;
}

.mod-ct .detail-open {
  border-top: 1px solid #e5e5e5;
}

.mod-ct .detail .arrow {
  padding: 6px 34px;
  border: 1px solid #e5e5e5;
}

.mod-ct .detail .arrow .ico-arrow {
  display: inline-block;
  width: 20px;
  height: 11px;
  background: url("../../../assets/img/wechat-pay.png") -25px -100px no-repeat;
}

.mod-ct .detail-open .arrow .ico-arrow {
  display: inline-block;
  width: 20px;
  height: 11px;
  background: url("../../../assets/img/wechat-pay.png") 0 -100px no-repeat;
}

.mod-ct .detail-open .detail-ct {
  display: block;
}

.mod-ct .tip {
  margin-top: 20px;
  border-top: 1px dashed #e5e5e5;
  padding: 10px 0;
  position: relative;
}

.mod-ct .tip .ico-scan {
  display: inline-block;
  width: 56px;
  height: 55px;
  background: url("../../../assets/img/wechat-pay.png") 0 0 no-repeat;
  vertical-align: middle;
  *display: inline;
  *zoom: 1;
}

.mod-ct .tip .tip-text {
  display: inline-block;
  vertical-align: middle;
  text-align: left;
  margin-left: 23px;
  font-size: 16px;
  line-height: 28px;
  *display: inline;
  *zoom: 1;
}

.mod-ct .tip .dec {
  display: inline-block;
  width: 22px;
  height: 45px;
  background: url("../../../assets/img/wechat-pay.png") 0 -55px no-repeat;
  position: absolute;
  top: -23px;
}

.mod-ct .tip .dec-left {
  background-position: 0 -55px;
  left: -136px;
}

.mod-ct .tip .dec-right {
  background-position: -25px -55px;
  right: -136px;
}

.foot {
  text-align: center;
  margin: 30px auto;
  color: #888888;
  font-size: 12px;
  line-height: 20px;
  font-family: "simsun";
}

.copyRight {
  text-align: center;
  color: rgba(97, 167, 184, 0.08);
  margin-bottom: 1px;
}

.copyRight a {
  color: rgba(88, 161, 184, 0.08);
}

h1 {
  font-family: "微软雅黑";
  font-size: 15px;
  margin: 5px 0;
  padding-bottom: 2px;
  letter-spacing: 2px;
}

.time-item strong {
  background: #3ec742;
  color: #fff;
  line-height: 25px;
  font-size: 15px;
  font-family: Arial;
  padding: 0 10px;
  margin-right: 10px;
  border-radius: 5px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
}

.item-title {
  background: none;
  line-height: 25px;
  font-size: 24px;
  padding: 0 10px;
  float: left;
}
.colon {
  display: inline-block;
  margin: 0 4px;
  color: #ee0a24;
}
.block {
  display: inline-block;
  width: 40px;
  border-radius: 5px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  background-color: #3ec742;
}
</style>